import { useCallback } from 'react';

import { isDocumentProjectType } from 'src/data/project';
import * as events from 'src/lib/events';
import { useErrorHandler, useTrackingEvent } from 'src/services';
import { useNotificationActions, useProjectActions, useProjectFolderActions } from 'src/store';
import { useProjectSettingsPopup } from 'src/views/ProjectSettingsPopup';

export const useMoveProject = () => {
  const openProjectSettingsPopup = useProjectSettingsPopup();
  const notificationActions = useNotificationActions();
  const trackEvent = useTrackingEvent();
  const handleError = useErrorHandler();
  const projectActions = useProjectActions();
  const projectFolderActions = useProjectFolderActions();

  return useCallback(
    (project) => {
      openProjectSettingsPopup({
        name: project.name,
        projectFolderId: project.projectFolder?.id,
        isDocument: isDocumentProjectType(project.type),
        displayName: false,
        displayMoveToFolder: true,
        onConfirm: async ({ projectFolderId, projectFolder }) => {
          try {
            await projectActions.moveProject({ id: project.id, projectFolderId });
            projectFolderActions.decreaseFolderProjectCount(project.projectFolder?.id);
            projectFolderActions.increaseFolderProjectCount(projectFolderId);

            trackEvent(events.PROJECT.projectMovedToFolder, {
              page: events.EVENT_PAGE.documents,
            });

            const targetFolderName = projectFolder?.name || 'All projects';
            notificationActions.displaySuccess(
              `‘${project.name}’ has been moved to ‘${targetFolderName}’`
            );
          } catch (error) {
            handleError(error);
          }
        },
      });
    },
    [
      openProjectSettingsPopup,
      projectActions,
      projectFolderActions,
      trackEvent,
      notificationActions,
      handleError,
    ]
  );
};
